import React from "react";
import Firstset from "./Set/Firstset";
import Secondset from "./Set/Secondset";
import Thirdset from "./Set/Thirdset";
import Fourthset from "./Set/Fourthset";
import Fifthset from "./Set/Fifthset";
import Sixthset from "./Set/Sixthset";
import Seventhset from "./Set/Seventhset";
import Eightset from "./Set/Eightset";

export default function Main() {
  return (
    <main className="relative">
      <Firstset />
      <Secondset />
      <Thirdset />
      <Fourthset />
      <Fifthset />
      <Sixthset />
      <Seventhset />
      <Eightset />
    </main>
  );
}
